// import React from 'react';
// export FormField from "./FormField"

// const FormField = require("./FormField")

/**
 * Funkce pro vložení formulářového fieldu na formulář. Dává se jako component vstup pro redux Field komponentu.
 * Fukce pro renderování vlastního inputu a labelu používá komponentu FormField.
 * @param inputField reálná input komponenta ve formuláři
 * @returns {Function}
 */
// export function field(inputField) {
//     return function(props) {
//         return <FormField {...props} inputField={inputField} />
//     }
// }

export McField from "./McField"
export String from "./StringField"
export Number from "./NumberField"
export Textarea from "./TextareaField"
export Checkbox from "./CheckboxField"
export SimpleSuggest from "./SimpleSuggestField"
export ObjectSuggest from "./ObjectSuggestField"
export ApiObjectSuggest from "./ApiObjectSuggestField"
export Select from "./SelectField"
export Subjekt from "./SubjektField"
export Obec from "./ObecField"
export Adresa from "./AdresaField"
export Kontakt from "./KontaktField"
export SimpleDate from "./DateField"
export Time from "./TimeField"
export CustomSelect from "./CustomSelectField"
export Static from "./StaticField"
export SubjektDoklad from "./SubjektDokladField"
export PravniForma from "./PravniFormaField"
export Stat from "./StatField"
export TypPrestupku from "./TypPrestupkuField"
export CastkaMena from "./CastkaMenaField"
export JednotkaTyp from "./JednotkaTypField"
export Pracovnik from "./PracovnikField"
export Search from "./SearchField"
export ObjectTag from "./ObjectTagField"
export TypObalky from "./TypObalkyField"
export ListSelect from "./ListSelectField"
export ImageSelect from "./ImageSelectField"
export File from "./FileField"
export Sablona from "./SablonaField"
export KategorieUredniDesky from "./KategorieUredniDeskyField"
export Autocomplete from "./AutocompleteField"
export Autocomplete2 from "./AutocompleteField2"
export TypDokument from './TypDokumentField'
export SpsTypDokument from './SpsTypDokumentField'
export StoreSuggest from './StoreSuggestField'
export StateSuggest from './StateSuggestField'
export Objekt from './ObjektField'
export Ctecka from "./CteckaField"
